/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayerNoteDtoResult } from '../../models/player-note-dto-result';
import { UpdatePlayerNoteCommand } from '../../models/update-player-note-command';

export interface ApiPlayerNotesPut$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Params {
      body?: UpdatePlayerNoteCommand
}

export function apiPlayerNotesPut$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: ApiPlayerNotesPut$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerNoteDtoResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerNotesPut$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=none');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=minimal;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerNoteDtoResult>;
    })
  );
}

apiPlayerNotesPut$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue.PATH = '/api/player-notes';
